import { gsap } from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"
import { SplitText } from "gsap/SplitText"
gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(SplitText);

export default {
  init() {

    gsap.config({ nullTargetWarn: false });

    $('.smooth, .smooth a').click(function() {
      if (location.pathname.replace(/^\//,'') === this.pathname.replace(/^\//,'') && location.hostname === this.hostname) {
        $('.top-bar').removeClass('open');
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
        if (target.length) {
          $('html,body').animate({scrollTop: target.offset().top - 90}, 1000); // Set scroll speed here
          return false;
        }
      }
    });

    $(window).load(function(e) {
      var url_string = window.location.search; 
      console.log(url_string);
      // var url = new URL(url_string);
      // var c = url.searchParams.get("c");
      // console.log(c);
      // if (urlParams) {

      // }
    });

    $('.hamburger').on('click', function(event) {
      $('.top-bar-right').toggleClass('open');
      $(this).toggleClass('is-active');
      event.preventDefault();
    });

    $('.search-box a').on('click', function(event) {
      $(this).parent().parent().next().toggle();
      $('.wrap.container').toggleClass('search-open');
      event.preventDefault();
    });

    $('.close-search').on('click', function(event) {
      $(this).parent().hide();
      event.preventDefault();
    });

    $('.add-usr-form-trigger').on('click', function(event) {
      $('#add-usr-form').show();
      event.preventDefault();
    });

    $('#acct-tabs').on('change.zf.tabs', function() {
      $('#add-usr-form').hide();
    });

    $('.gb').on('click', function() {
      $('#add-usr-form').hide();
    });

    $('.marquee-w-img').slick({
      arrows: true,
      dots: false,
      autoplay: true,
      autoplaySpeed: 6000,
    });

    // Marquee Text

    let marqHeadline = document.querySelector('.marquee-w-img h1')
    let marqText = document.querySelectorAll('.marquee-w-img p')
    let scroller = document.querySelectorAll('marquee-w-img .button')
    gsap.to(marqHeadline, {opacity: 1, duration: 1.5, y: 0, ease: 'power4.out'})
    gsap.to(marqText, {opacity: 1, duration: 1.5, y: 0, ease: 'power4.out'}, '-=1')
    gsap.to(scroller, {opacity: 1, duration: 1.5, y: 0, ease: 'power4.out'}, '-=1')

    // Marquee Banner

    let mb = gsap.timeline({
      scrollTrigger: {
        trigger: '.marquee-banner',
        start: 'top center',
      },
    })
    mb.to('.marquee-banner h2', {y: 0, opacity: 1, duration: 1.5, ease: 'power4.out'})
    .to('.marquee-banner p', {y: 0, opacity: 1, duration: 1.5, ease: 'power4.out', stagger: {amount: 0.6}}, '-=1.5')
    .to('.marquee-banner a', {y: 0, opacity: 1, duration: 1.5, ease: 'power4.out'}, '-=1.5')


     // Marquee W/ Image

     let mwi = gsap.timeline({
      scrollTrigger: {
        trigger: '.marquee-w-img',
        start: 'top center',
      },
    })
     mwi.to('.marquee-w-img img', {y: 0, opacity: 1, duration: 1.5, ease: 'power4.out'})
     .to('.marquee-w-img h3', {y: 0, opacity: 1, duration: 1.5, ease: 'power4.out'}, '-=1.4')
     .to('.marquee-w-img .txt', {y: 0, opacity: 1, duration: 1.5, ease: 'power4.out'}, '-=1.3')
     .to('.marquee-w-img a', {y: 0, opacity: 1, duration: 1.5, ease: 'power4.out'}, '-=1.2')
     .to('.marquee-w-img .subtext', {y: 0, opacity: 1, duration: 1.5, ease: 'power4.out'}, '-=1')


     // Image Banner Animation
     let imgArray = gsap.utils.toArray('.img-bar');
     imgArray.forEach((img, i) => {
      let tl = gsap.timeline({
        scrollTrigger: {
          trigger: img,
          start: 'top center',
        },
      })
      tl.to(img.querySelector('h2'), {opacity: 1, y: 0, duration: 1, ease: 'power4.out'})
      .to(img.querySelector('.button'), {opacity: 1, y: 0, duration: 1, ease: 'power4.out'}, '-=1')
    });

     let tw = gsap.timeline({
      scrollTrigger: {
        trigger: '.team-wrp',
        start: 'top center',
      },
    })
     tw.to('.team-wrp h2', {y: 0, opacity: 1, duration: 1.5, ease: 'power4.out'})
     .to('.team-wrp .img', {opacity: 1, duration: 1.5, ease: 'power4.out', stagger: {amount: 0.6}}, '-=1.5')
     .to('.team-wrp .decoration', {bottom: '5vw', opacity: 0.7, duration: 1.5, ease: 'back.out(1.3)'}, '-=1.5')

     let lb = gsap.timeline({
      scrollTrigger: {
        trigger: '.list-box-wrap',
        start: 'top center',
      },
    })
     lb.to('.list-box-wrap h2', {y: 0, opacity: 1, duration: 1.5, ease: 'power4.out'})
     .to('.list-box-wrap .list-box', {opacity: 1, duration: 1.5, ease: 'power4.out'}, '-=1.5')

     // Team Archive 

     const greenHeadline = document.querySelector('.green h1');
     const greenImgs = document.querySelectorAll('.green .img')
     const greenSubHealdine = document.querySelector('.green h3');
     const blueBg = document.querySelector('.blue');
     const blueHeadline = document.querySelector('.blue h1');
     const blueImgs = document.querySelectorAll('.blue .img')
     const blueSubHealdine = document.querySelector('.blue h3');
     const purpleBg = document.querySelector('.purple');
     const purpleHeadline = document.querySelector('.purple h1');
     const purpleImgs = document.querySelectorAll('.purple .img')
     const purpleSubHealdine = document.querySelector('.purple h3');

     let green = gsap.timeline({
      scrollTrigger: {
        trigger: '.green',
        start: 'top center',
      },
    })
     green.to(greenHeadline, {y: 0, opacity: 1, duration: 1.5, ease: 'power4.out'})
     .to(greenSubHealdine, {y: 0, opacity: 1, duration: 1.5, ease: 'power4.out', stagger: {amount: 0.6}}, '-=1.5')
     .to(greenImgs, {y: 0, opacity: 1, duration: 1.5, ease: 'back.out(1.3)', stagger: {amount: 0.6}}, '-=1.5')


     let blue = gsap.timeline({
      scrollTrigger: {
        trigger: '.blue',
        start: 'top center',
      },
    })
     blue.to(blueBg, {backgroundColor: '#0079ea', duration: 1.5, ease: 'power4.out'})
     .to(blueHeadline, {y: 0, opacity: 1, duration: 1.5, ease: 'power4.out'}, '-=1.5')
     .to(blueSubHealdine, {y: 0, opacity: 1, duration: 1.5, ease: 'power4.out', stagger: {amount: 0.6}}, '-=1.5')
     .to(blueImgs, {y: 0, opacity: 1, duration: 1.5, ease: 'back.out(1.3)', stagger: {amount: 0.6}}, '-=1.5')

     let purple = gsap.timeline({
      scrollTrigger: {
        trigger: '.purple',
        start: 'top center',
      },
    })
     purple.to(purpleBg, {backgroundColor: '#a44ff5', duration: 1.5, ease: 'power4.out'})
     .to(purpleHeadline, {y: 0, opacity: 1, duration: 1.5, ease: 'power4.out'}, '-=1.5')
     .to(purpleSubHealdine, {y: 0, opacity: 1, duration: 1.5, ease: 'power4.out', stagger: {amount: 0.6}}, '-=1.5')
     .to(purpleImgs, {y: 0, opacity: 1, duration: 1.5, ease: 'back.out(1.3)', stagger: {amount: 0.6}}, '-=1.5')


     // Stats

     const statHeadline = document.querySelector('.stats h2');
     const statText = document.querySelectorAll('.stats p')
     const statSlider = document.querySelector('.stats .stat-list');

     let stats = gsap.timeline({
      scrollTrigger: {
        trigger: '.stats',
        start: 'top center',
      },
    })
     stats.to(statHeadline, {y: 0, opacity: 1, duration: 1.5, ease: 'power4.out'})
     .to(statText, {y: 0, opacity: 1, duration: 1.5, ease: 'power4.out'}, '-=1')
     .to(statSlider, {y: 0, opacity: 1, duration: 1.5, ease: 'power4.out'}, '-=1')


     // CC Circles

     const ccHeadline = document.querySelector('.carousel-circles h2')
     const ccText = document.querySelector('.carousel-circles p')
     const ccTextSpOne = new SplitText('.carousel-circles h2 span.one', {type: 'chars'})
     const ccTextSpTwo = new SplitText('.carousel-circles h2 span.two', {type: 'chars'})
     const ccSlides = document.querySelector('.circle-slides')

     let cCircles = gsap.timeline({
      scrollTrigger: {
        trigger: '.carousel-circles',
        start: 'top center',
      },
    })
     cCircles.to(ccHeadline, {y: 0, opacity: 1, duration: 1.5, ease: 'power4.out'})
     .to(ccText, {y: 0, opacity: 1, duration: 1.5, ease: 'power4.out'}, '-=1')
     .to(ccTextSpOne.chars, {color: '#f76905', duration: 1.5, ease: 'power4.out', stagger: {amount: 0.3}}, '-=1')
     .to(ccTextSpTwo.chars, {color: '#f76905', duration: 1.5, ease: 'power4.out', stagger: {amount: 0.3}}, '-=1')
     .to(ccSlides, {opacity: 1, duration: 1.5, ease: 'power4.out'}, '-=1')

     // Cols Split

     const colsHeadline = document.querySelector('.callout-cols h2');
     const colsSubHealdine = document.querySelector('.callout-cols p');

     let cols = gsap.timeline({
      scrollTrigger: {
        trigger: '.callout-cols',
        start: 'top center',
      },
    })
     cols.to(colsHeadline, {y: 0, opacity: 1, duration: 1.5, ease: 'back.out(1.3)'})
     .to(colsSubHealdine, {y: 0, opacity: 1, duration: 1.5, ease: 'back.out(1.3)'}, '-=1')


     // Accordion Comp

     const accHeadline = document.querySelector('.accordion-comp h2')
     const accText = document.querySelector('.accordion-comp .intro')
     const accList = document.querySelector('.accordion-comp .accordion')

     let accComp = gsap.timeline({
      scrollTrigger: {
        trigger: '.accordion-comp',
        start: 'top center',
      },
    })
     accComp.to(accHeadline, {y: 0, opacity: 1, duration: 1.5, ease: 'power4.out'})
     .to(accText, {y: 0, opacity: 1, duration: 1.5, ease: 'power4.out'}, '-=1')
     .to(accList, {y: 0, opacity: 1, duration: 1.5, ease: 'power4.out'}, '-=1')


     // Arrow

     const arrowPurple = document.querySelector('.arrow-banner .purple')
     const arrowLogo = document.querySelector('.arrow-banner .purple img')
     const arrowText = document.querySelectorAll('.arrow-banner .ol')

     let arrowComp = gsap.timeline({
      scrollTrigger: {
        trigger: '.arrow-banner',
        start: 'top center',
      },
    })
     arrowComp.to(arrowPurple, {x: 0, opacity: 1, duration: 1.5, ease: 'back.out(1.1)'})
     .to(arrowLogo, {opacity: 1, duration: 1.5, ease: 'power4.out'}, '-=0.2')
     .to(arrowText, {opacity: 1, duration: 1.5, ease: 'power4.out', stagger: {amount: 0.3}}, '-=1')

     // Buckets

     const bucketsHeadline = document.querySelector('.buckets h2')
     const bucketsIntroText = document.querySelector('.buckets .intro-text')
     const bucketsHighlight1 = new SplitText('.buckets h2 .highlight1', {type: 'chars'})
     const bucketsHighlight2 = new SplitText('.buckets h2 .highlight2', {type: 'chars'})
     const bucketsHighlight3 = new SplitText('.buckets h2 .highlight3', {type: 'chars'})
     const bucketsText = document.querySelector('.buckets .div-text')
     const bucketsLine1 = document.querySelector('.buckets .inner.l')
     const bucketsLine2 = document.querySelector('.buckets .inner.r')
     const bucket = document.querySelectorAll('.buckets .bucket')
     const focus = document.querySelectorAll('.focus')

     let buckComp = gsap.timeline({
      scrollTrigger: {
        trigger: '.buckets',
        start: 'top 70%',
      },
    })
     buckComp.to(bucketsHeadline, {y: 0, opacity: 1, duration: 1.5, ease: 'power4.out'})
     .to(bucketsIntroText, {y: 0, opacity: 1, duration: 1.5, ease: 'power4.out'}, '-=1')
     .to(bucketsHighlight1.chars, {color: '#a44ff5', duration: 1.5, ease: 'power4.out', stagger: {amount: 0.3}}, '-=1')
     .to(bucketsHighlight2.chars, {color: '#a44ff5', duration: 1.5, ease: 'power4.out', stagger: {amount: 0.3}}, '-=1')
     .to(bucketsHighlight3.chars, {color: '#a44ff5', duration: 1.5, ease: 'power4.out', stagger: {amount: 0.3}}, '-=1')
     .to(bucketsText, {y: 0, opacity: 1, duration: 1.5, ease: 'power4.out'}, '-=1.5')
     .to(bucketsLine1, {width: '100%', duration: 1.5, ease: 'power4.out'}, '-=1.5')
     .to(bucketsLine2, {width: '100%', duration: 1.5, ease: 'power4.out'}, '-=1.5')
     .to(bucket, {y: 0, opacity: 1, duration: 1.5, ease: 'power4.out', stagger: {amount: 0.5}}, '-=1')
     .to(focus, {y: 0, opacity: 1, duration: 1.5, ease: 'power4.out', stagger: {amount: 0.5}}, '-=1')


     // Split Text

     const splitLeft = document.querySelector('.split.text h2')
     const splitRight = document.querySelector('.split.text p')

     let splitText = gsap.timeline({
      scrollTrigger: {
        trigger: '.split.text',
        start: 'top center',
      },
    })
     splitText.to(splitLeft, {y: 0, opacity: 1, duration: 1.5, ease: 'power4.out'})
     .to(splitRight, {y: 0, opacity: 1, duration: 1.5, ease: 'power4.out'}, '-=1')

     // Accordion

     const tabWrap = document.querySelector('.tab-wrap')

     let tabWrp = gsap.timeline({
      scrollTrigger: {
        trigger: '.tab-wrap',
        start: 'top center',
      },
    })
     tabWrp.to(tabWrap, {y: 0, opacity: 1, duration: 1.5, ease: 'power4.out'})


     // Text Area

     const txt = gsap.utils.toArray('.txt')
     txt.forEach((t, i) => {
      let txtWrp = gsap.timeline({
        scrollTrigger: {
          trigger: t,
          start: 'top 70%',
        },
      })
      txtWrp.to(t.querySelector('h3'), {y: 0, opacity: 1, duration: 1.5, ease: 'power4.out'})
      .to(t.querySelectorAll('p'), {y: 0, opacity: 1, duration: 1.5, ease: 'power4.out', stagger: {amount: 0.6}}, '-=1')
    })


     // Split

     const split = gsap.utils.toArray('.sixfour-split')
     split.forEach((sp, i) => {
      let splitWrp = gsap.timeline({
        scrollTrigger: {
          trigger: sp,
          start: 'top 70%',
        },
      })
      splitWrp.to(sp, {opacity: 1, duration: 1.5, ease: 'power4.out'})
      .to(sp.querySelector('img'), {x: 0, opacity: 1, boxShadow: '55px -1px 0px 13px #4472c4', duration: 1.5, ease: 'power4.out'}, '-=1')
      .to(sp.querySelector('h2'), {y: 0, opacity: 1, duration: 1.5, ease: 'power4.out'}, '-=1')
      .to(sp.querySelector('p'), {y: 0, opacity: 1, duration: 1.5, ease: 'power4.out'}, '-=1')
    })


     // Split Boxes

     const splitBxs = gsap.utils.toArray('.split-boxes')
     splitBxs.forEach((spb, i) => {
      let splitBx = gsap.timeline({
        scrollTrigger: {
          trigger: spb,
          start: 'top 70%',
        },
      })
      splitBx.to(spb.querySelector('img'), {y: 0, opacity: 1, duration: 1.5, ease: 'power4.out'})
      .to(spb.querySelectorAll('.icon-box'), {y: 0, opacity: 1, duration: 1.5, ease: 'power4.out', stagger: {amount: 0.6}}, '-=1')
    })

     // Fifty Fifty

     const fiftysplit = gsap.utils.toArray('.fifty-split')
     fiftysplit.forEach((fif, i) => {
      let fiftFifty = gsap.timeline({
        scrollTrigger: {
          trigger: fif,
          start: 'top center',
        },
      })
      fiftFifty.to(fif.querySelector('img'), {y: 0, opacity: 1, duration: 1, ease: 'power4.out'})
      .to(fif.querySelector('h2'), {y: 0, opacity: 1, duration: 1, ease: 'power4.out'}, '-=1')
      .to(fif.querySelector('.blue-line'), {height: '60%', duration: 1, ease: 'power4.out'}, '-=1')
      .to(fif.querySelector('h3'), {y: 0, opacity: 1, duration: 1, ease: 'power4.out'}, '-=0.9')
      .to(fif.querySelectorAll('p'), {y: 0, opacity: 1, duration: 1, ease: 'power4.out'}, '-=0.8')
      .to(fif.querySelectorAll('li'), {y: 0, opacity: 1, duration: 1, ease: 'power4.out', stagger: {amount: 0.3}}, '-=0.7')
      .to(fif.querySelectorAll('a'), {y: 0, opacity: 1, duration: 1, ease: 'power4.out', stagger: {amount: 0.3}}, '-=0.6')
    })

     // Contact Split

     const fiftysplitct = gsap.utils.toArray('.fifty-split.ct')
     fiftysplitct.forEach((fct, i) => {
      let fiftFifty = gsap.timeline({
        scrollTrigger: {
          trigger: fct,
          start: 'top center',
        },
      })
      fiftFifty.to(fct.querySelector('.full-pane'), {y: 0, opacity: 1, duration: 1.5, ease: 'power4.out'})
    })


    // Split Alt

    const splitAlt = gsap.utils.toArray('.sixfour-split-alt')
    splitAlt.forEach((spA, i) => {
      let splitWrp = gsap.timeline({
        scrollTrigger: {
          trigger: spA,
          start: 'top 70%',
        },
      })
      splitWrp.to(spA, {opacity: 1, duration: 1.5, ease: 'power4.out'})
      .to(spA.querySelector('img'), {y: 0, opacity: 1, duration: 1.5, ease: 'power4.out'}, '-=1')
      .to(spA.querySelectorAll('.icon-box'), {y: 0, opacity: 1, duration: 1.5, ease: 'power4.out', stagger: {amount: 0.6}}, '-=1')
    }) 

     // Accordion

     $('.tabs-title:first-of-type').addClass('is-active');
     $('.tabs-title:first-of-type a').attr('aria-selected', 'true');
     $('.tabs-panel:first-of-type').addClass('is-active');


     // Cart Total

     $('#choice_8_12_1').on('click', function(event) {

      let totalCurrency = Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
      });


      $('#input_8_11').on('focusout', function() {
        sessionStorage.setItem('donation', $(this).val());
        $('.don').append(sessionStorage.getItem('donation'));
        let prodPrice = Number($('.prod-price').text().replace(/[^0-9.-]+/g, ""));
        let donation = Number($('.don').text().replace(/[^0-9.-]+/g, ""));
        let total = prodPrice + donation;
        $('.tot').append(totalCurrency.format(total));
      });
    });

     $('.show-player').on('click', function(event) {
      $(this).next().slideToggle();
      event.preventDefault();
    });  

    // Form Helpers

    $('.readonly input').attr("readonly","readonly");


    window.renderAssetSearch = function(file, type) {
      document.querySelector('.spinner').style.display = 'block';
      $('#asset-rev').foundation('open');
      setTimeout(() => {
        let postData = type+'&'+file;
        $.ajax({
         type: "POST",
         url: '/wp-content/themes/sage-foundation/resources/render-ajax.php',
         data: { file: file, type: type },
         beforeSend:function(data) {
           document.querySelector('.spinner').style.display = 'block';
         },
         success:function(data) {
          document.querySelector('.spinner').style.display = 'none';
          $('#asset-rev').html(data);
        },
      });
      }, '500');
    }
    
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js